import React, { useState, useEffect, useRef } from 'react';
import ChatInput from './ChatInput';
import ChatMessage from './ChatMessage';

function ChatLayoutDesktop({ chatInfo }) {
  const [messages, setMessages] = useState([
    {
      fromUser: false,
      message: `You're now speaking to ${chatInfo.contact} about "${chatInfo.subject}".`,
      time: new Date(),
    },
    {
      fromUser: false,
      message: `Hello ${chatInfo.name}, I'm here to listen.`,
      time: new Date(),
    },
  ]);

  const chatRef = useRef(null);

  const handleSendMessage = async (text) => {
    const userMsg = {
      fromUser: true,
      message: text,
      time: new Date(),
    };
    setMessages((prev) => [...prev, userMsg]);

    try {
      const res = await fetch('https://sausebot.resolvedchallenge.com/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: text,
          name: chatInfo.name,
          subject: chatInfo.subject,
          contact: chatInfo.contact,
        }),
      });

      const data = await res.json();

      const aiMsg = {
        fromUser: false,
        message: data.response || "I'm here to listen.",
        time: new Date(),
      };

      setMessages((prev) => [...prev, aiMsg]);
    } catch (err) {
      console.error('❌ Backend error:', err);
      setMessages((prev) => [
        ...prev,
        {
          fromUser: false,
          message: 'Sorry, something went wrong. Please try again.',
          time: new Date(),
        },
      ]);
    }
  };

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div className="desktop-wrapper">
      {/* Left banner (optional ad or filler) */}
      <div className="banner-side left-banner">Left Ad</div>

      {/* Main chat area */}
      <div className="chat-container-desktop">
        <div className="chat-header">💻 DESKTOP VIEW</div>

        <div ref={chatRef} className="chat-body">
          {messages.map((msg, idx) => (
            <ChatMessage key={idx} {...msg} />
          ))}
        </div>

        <ChatInput onSend={handleSendMessage} />
      </div>

      {/* Right banner */}
      <div className="banner-side right-banner">Right Ad</div>
    </div>
  );
}

export default ChatLayoutDesktop;
